module.exports = __webpack_public_path__ + "img/thumbnail_AfricanPenguin_f_albino.4bb68593.png";